import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {reportToaster} from '../../../shared/store/epics/reportEpics';
import {useReportIsDirty} from '../../../shared/hooks';
import {IState} from '../../../shared/store/reducers';
import {ApiStatus} from '../../../shared/models';

const showToaster = () => {
  reportToaster.show({
    message: 'Report updated successfully',
    intent: 'success',
    timeout: 3000, // Auto-dismiss after 3 seconds
  });
}

export const useReportUpdatedToaster = () => {
  /*
   * Used only when autosave is disabled, on the ReportForm.
   */
  const updatingStatus = useSelector((state: IState) => state.reportForm.updatingStatus);
  const workflowUpdatingStatus = useSelector((state: IState) => state.workflows.updatingStatus);
  const webhookUpdatingStatus = useSelector((state: IState) => state.webhook.updatingStatus);
  const isUpdating = updatingStatus === ApiStatus.LOADING;
  const isWorkflowUpdating = workflowUpdatingStatus === ApiStatus.LOADING;
  const isWebhookUpdating = webhookUpdatingStatus === ApiStatus.LOADING;
  const updated = updatingStatus === ApiStatus.LOADED; // successfully updated
  const workflowUpdated = workflowUpdatingStatus === ApiStatus.LOADED; // successfully updated
  const webhookUpdated = webhookUpdatingStatus === ApiStatus.LOADED; // successfully updated

  const {isDirty} = useReportIsDirty();

  useEffect(() => {
    if (!isDirty && !isUpdating && updated) {
      showToaster();
    }
  }, [isDirty, isUpdating, updated]);

  useEffect(() => {
    if (!isWorkflowUpdating && workflowUpdated) {
      showToaster();
    }
  }, [isWorkflowUpdating, workflowUpdated]);

  useEffect(() => {
    if (!isWebhookUpdating && webhookUpdated) {
      showToaster();
    }
  }, [isWebhookUpdating, webhookUpdated]);
};
